import styled, { css, keyframes, ThemeProvider } from 'styled-components'

export default styled
export { css, keyframes, ThemeProvider }
